import { Condition } from "../components/alfie-chat"

  export const pharmacies = [
    { id: "1", name: "QuickCare Pharmacy", address: "123 Main St - NY 10003." },
    { id: "2", name: "HealthPlus Pharmacy", address: "456 Oak Ave -NY 10003." },
    { id: "3", name: "QuickCare Pharmacy", address: "123 Main St - NY 10003." },
    { id: "4", name: "QuickCare Pharmacy", address: "123 Main St - NY 10003." },
    { id: "5", name: "QuickCare Pharmacy", address: "123 Main St - NY 10003." },
  ]

  export const conditions: Condition[] = [
    {
      id: "diabetes",
      name: "Diabetes",
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Diabetes?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    {
      id: "hypertension",
      name: "Hypertension",
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Hypertension?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    {
      id: "asthma",
      name: "Asthma",
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Asthma?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "heart_disease", 
      name: "Heart disease", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Heart disease?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "high_cholesterol", 
      name: "High cholesterol", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with High cholesterol?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "thyroid_issues", 
      name: "Thyroid issues", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Thyroid issues?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "anxiety", 
      name: "Anxiety", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Anxiety?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "depression", 
      name: "Depression", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Depression?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "ulcer", 
      name: "Ulcer", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Ulcer?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "hepatitis", 
      name: "Hepatitis B or C", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Hepatitis B or C?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "cancer", 
      name: "Cancer", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Cancer?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "tuberculosis", 
      name: "Tuberculosis", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Tuberculosis?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "sickle_cell", 
      name: "Sickle cell", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Sickle cell?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "kidney_disease", 
      name: "Kidney disease", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Kidney disease?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "liver_disease", 
      name: "Liver disease", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Liver disease?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "stroke", 
      name: "Stroke", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Stroke?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "epilepsy", 
      name: "Epilepsy", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Epilepsy?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
    { 
      id: "migraine", 
      name: "Migraine", 
      questions: [
        { id: "diagnosed", text: "Have you been formally diagnosed with Migraine?", type: "boolean" },
        { id: "diagnosedDate", text: "When did you get diagnosed?", type: "date" },
        { id: "medications", text: "What medication(s) are you taking?", type: "text" },
      ],
    },
  ]

 export const redFlagQuestions = [
    { id: "chest_pain", text: "Are you experiencing severe chest pain?" },
    { id: "breathing", text: "Are you having difficulty breathing?" },
    { id: "unconscious", text: "Have you recently lost consciousness?" },
  ]